import { Gamecloud } from '../../gamecloud';
import { createRestartInstances, RestartUI } from './restartUI';

class Restart extends Gamecloud {
  public constructor(private ui: RestartUI) {
    super();

    this.ui.onScheduleChange();
  }
}

export function initRestarts() {
  const instances = createRestartInstances();
  return instances.map((ui: RestartUI) => {
    return new Restart(ui);
  });
}
